/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droplinksearchplaceholder3Inputs */

const en_droplinksearchplaceholder3 = /** @type {(inputs: Droplinksearchplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by title…`)
};

const de_droplinksearchplaceholder3 = /** @type {(inputs: Droplinksearchplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Titel suchen…`)
};

/**
* | output |
* | --- |
* | "Search by title…" |
*
* @param {Droplinksearchplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droplinksearchplaceholder3 = /** @type {((inputs?: Droplinksearchplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droplinksearchplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droplinksearchplaceholder3(inputs)
	return de_droplinksearchplaceholder3(inputs)
});
export { droplinksearchplaceholder3 as "dropLinkSearchPlaceholder" }